module.exports = __webpack_public_path__ + "img/no-board-report.b5466550.svg";